import type { LabV2Popup } from 'lib/labV2/popups'
import { popupSeenUntil } from 'lib/labV2/popups'
import { isExpiringDismissalActive, setExpiringDismissal } from './expiringDismissalEntry'
import { hasPresentedLabModalThisSession, recordLabModalSessionGate } from './modalPopup'

const KEY_PREFIX = 'labV2ModalPopup:'

function storageKey(id: number) {
  return `${KEY_PREFIX}${id}`
}

export function isLabV2ModalSuppressed(popup: LabV2Popup): boolean {
  if (hasPresentedLabModalThisSession()) {
    return true
  }
  return isExpiringDismissalActive(storageKey(popup.id))
}

export function recordLabV2ModalSeen(popup: LabV2Popup, now = new Date()) {
  recordLabModalSessionGate()
  setExpiringDismissal(storageKey(popup.id), popupSeenUntil(popup.displayFrequency, now))
}
